var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-blur-filter",attrs:{"height":"0","width":"0"}},[_c('defs',[_c('filter',{attrs:{"id":"path-dropshadow"}},[_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }